"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _DropdownList = _interopRequireDefault(require("@insided/shared/uikit/dropdown/DropdownList"));

var _classnames = _interopRequireDefault(require("classnames"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ButtonControlSelector = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ButtonControlSelector, _Component);

  var _super = _createSuper(ButtonControlSelector);

  function ButtonControlSelector(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ButtonControlSelector);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "root", null);
    _this.state = {
      visible: false
    };
    _this.documentClick = _this.documentClick.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(ButtonControlSelector, [{
    key: "addHandler",
    value: function addHandler() {
      window.document.addEventListener('click', this.documentClick);
    }
  }, {
    key: "removeHandler",
    value: function removeHandler() {
      window.document.removeEventListener('click', this.documentClick);
    }
  }, {
    key: "documentClick",
    value: function documentClick(e) {
      var _this$root;

      var target = e.target;

      function isNode(e) {
        return !!e && 'childNodes' in e;
      }

      if (!this.root) return;
      if (!isNode(target)) return;
      if ((_this$root = this.root) !== null && _this$root !== void 0 && _this$root.contains(target)) return;
      this.removeHandler();
      this.setState({
        visible: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _principal$disabled,
          _this2 = this,
          _principal$titleWithI;

      var _this$props = this.props,
          items = _this$props.items,
          size = _this$props.size,
          triggerButtonCustomClassName = _this$props.triggerButtonCustomClassName,
          _this$props$variant = _this$props.variant,
          variant = _this$props$variant === void 0 ? 'primary' : _this$props$variant,
          _this$props$iconClose = _this$props.iconCloseName,
          iconCloseName = _this$props$iconClose === void 0 ? 'arrowDropUp' : _this$props$iconClose,
          _this$props$iconOpenN = _this$props.iconOpenName,
          iconOpenName = _this$props$iconOpenN === void 0 ? 'arrowDropdown' : _this$props$iconOpenN,
          disabled = _this$props.disabled;
      var visible = this.state.visible;
      var principal = items.filter(function (item) {
        return item.isPrincipal;
      })[0];
      var isPrincipalDisabled = (_principal$disabled = principal.disabled) !== null && _principal$disabled !== void 0 ? _principal$disabled : disabled;
      return (0, _preact.h)("div", {
        className: "selector-buttons",
        ref: function ref(el) {
          _this2.root = el;
        }
      }, (0, _preact.h)("a", {
        href: (0, _absoluteUrlRuntime.resolveUrl)(principal.href)
      }, (0, _preact.h)(_Button.default, {
        variant: variant,
        size: size,
        title: (_principal$titleWithI = principal.titleWithIcon) !== null && _principal$titleWithI !== void 0 ? _principal$titleWithI : principal.title,
        onClick: principal.onClick,
        className: (0, _classnames.default)(principal.class, items.length === 1 && 'selector-button--hide-arrow'),
        disabled: isPrincipalDisabled
      })), items.length > 1 && (0, _preact.h)(_Button.default, {
        disabled: disabled,
        variant: variant,
        size: size,
        className: triggerButtonCustomClassName,
        icon: visible ? iconCloseName : iconOpenName,
        onClick: function onClick(event) {
          if (!visible) {
            _this2.addHandler();

            event.stopPropagation();
          } else {
            _this2.removeHandler();
          }

          _this2.setState({
            visible: !visible
          });
        }
      }), visible && (0, _preact.h)("div", {
        className: "selector-wrapper"
      }, (0, _preact.h)(_DropdownList.default, {
        align: "adjust",
        items: items.filter(function (item) {
          return !item.isPrincipal;
        }),
        isOpen: visible,
        hasSearch: false
      })));
    }
  }]);
  return ButtonControlSelector;
}(_preact.Component);

exports.default = ButtonControlSelector;